var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAioaIconType18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,0.2C14.5,0.2,0.3,14.6,0.3,32.1S14.5,63.8,32,63.8s31.7-14.4,31.7-31.8S49.5,0.2,32,0.2z M32,58.9 c-14.9,0-26.9-12-26.9-26.9S17.1,5,32,5s26.9,12,26.9,26.9S46.9,58.9,32,58.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.3,44.2l-8.9-8.9h-8.2l0.1-9.2v-2.3c0-1.6-1.2-2.9-2.9-3c-1.7,0-3,1.3-3,2.9v15.4c0,1.2,0.9,2.1,2.1,2.1 h9.6l7.1,7.1c0.5,0.6,1.3,0.9,2.1,0.9c0.8,0,1.5-0.3,2-0.9c0.6-0.5,0.9-1.3,0.9-2.1S48.8,44.8,48.3,44.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.5,19.4c2.4,0,4.3-1.9,4.3-4.3s-1.9-4.3-4.3-4.3s-4.3,1.9-4.3,4.3S26.1,19.4,28.5,19.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.5,44.6c-2.9,5-9.2,6.7-14.2,3.8c-2.4-1.4-4.1-3.6-4.8-6.3s-0.4-5.5,1-7.9c1.1-1.9,2.6-3.3,4.4-4.1 l0.3-0.1v-3.8l-0.7,0.3c-3.4,1.3-6.1,3.9-7.6,7.3c-1.5,3.4-1.5,7.2-0.2,10.6c1.3,3.4,3.9,6.1,7.3,7.6c1.8,0.8,3.6,1.2,5.5,1.2 c1.7,0,3.4-0.3,5.1-1c2.6-1,4.9-2.9,6.5-5.4l0.2-0.4L37.8,44L37.5,44.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAioaIconType18);
export default __webpack_public_path__ + "static/media/aioa-icon-type-18.d3f076d61fdee6dc02aab18222c52217.svg";
export { ForwardRef as ReactComponent };